import values from "lodash/values";
export const LOG_LEVEL = {
    DEBUG: 1,
    INFO: 2,
    WARNING: 3,
    ERROR: 4
};
export const LOG_LEVEL_VALUES = values(LOG_LEVEL);
